import React from 'react'

function Tutorials() {
  return (
    <div>Tutorials</div>
  )
}

export default Tutorials